import React, { useState } from "react";
import "./Faq.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What is Pamundo?",
      answer:
        "Pamundo is a marketplace that connects retailers with wholesalers who sell and distribute ethnic products in the United States.",
    },
    {
      question: "Who is PAMUNDO for?",
      answer:
        "Pamundo is designed for both retailers and wholesalers in the ethnic products industry. Retailers can easily find and order products, while wholesalers can showcase their products and manage orders effectively.",
    },
    {
      question: "How can I get started on PAMUNDO?",
      answer: [
        "For Retailers: Download and register to use the Pamundo app, available on Google Play Store and Apple Store.",
        "For Wholesalers: Contact support@pamundo.io for assistance with the onboarding process",
      ],
    },
    {
      question: "Why should I use PAMUNDO?",
      answer:
        "Pamundo streamlines traditional ordering methods, making it easier for retailers to access ethnic products and for wholesalers to manage their operations. It saves time, improves efficiency, and enhances visibility in the ethnic product market.",
    },
  ];

  const toggleFAQ = (index: any) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq">
      <h2 className="faq__title">Frequently Asked Questions</h2>
      <div className="faq__content">
        {faqs.map((faq, index) => (
          <div key={index} className="faq__item">
            <div className="faq__question" onClick={() => toggleFAQ(index)}>
              <span>{faq.question}</span>
              {openIndex === index ? (
                <ExpandLessIcon className="faq__icon" />
              ) : (
                <ExpandMoreIcon className="faq__icon" />
              )}
            </div>
            {openIndex === index && (
              <div className="faq__answer">
                {Array.isArray(faq.answer) ? (
                  <ul>
                    {faq.answer.map((line, i) => (
                      <li key={i}>{line}</li>
                    ))}
                  </ul>
                ) : (
                  <p>{faq.answer}</p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
